// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AppRoutes from './routes';
import AdminRoutes from './routes/adminRoutes';
import { AuthProvider } from './context/AuthContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import EnvSwitcher from './components/EnvSwitcher';
import config from './config/config';



const App = () => {
  return (
    <AuthProvider>
      <Router basename="/adira">
        <Routes>
          <Route path="/admin/*" element={<AdminRoutes />} />
          <Route path="/*" element={<AppRoutes />} />
        </Routes>
        <ToastContainer 
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          containerId="main-toast-container"
        />
        {config.isDevelopment() && <EnvSwitcher />}
      </Router>
    </AuthProvider>
  );
};

export default App;
// "npm --prefix \"$RESOURCE_DIR\" run lint"
